import React, { FC } from 'react';
import CheckoutMySummary, { CheckoutMySummaryProps } from '../CheckoutMySummary';

const MySummary: FC<CheckoutMySummaryProps> = ({ carDetails, ...rest }: CheckoutMySummaryProps) => {
    const props: CheckoutMySummaryProps = {
        isSecondaryLayout: true,
        myAccountCarDetails: carDetails,
        ...rest,
    };
    return <CheckoutMySummary {...props} />;
};

export { MySummary };
